
import { AnalyticReport } from '@app/core/models/admin/analytic-report';
import { UserRole } from '@core/models/admin/user-role';
import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { loadAnalyticReportsSuccess, loadUserRolesSuccess } from '../actions/admin.actions';

export interface AdminState {
  userRoles?: UserRole[];
  analyticReports?: AnalyticReport[];
}

const initialState: AdminState = {
  userRoles: [],
  analyticReports: []
};

export const adminReducer = createReducer(
  initialState,
  on(loadUserRolesSuccess, (state, action) => ({ ...state, userRoles: action.payload })),
  on(loadAnalyticReportsSuccess, (state, action) => ({ ...state, analyticReports: action.payload }))
);

export const selectAdminState = createFeatureSelector<AdminState>('adminState');
